declare const __THREADBOUND_VERSION__: string;

/** Build hash injected by Vite. Tests and a missing define read as dev. */
export function gameVersion(): string {
  try {
    const value = __THREADBOUND_VERSION__;
    if (typeof value !== 'string' || value.length < 1) return 'dev';
    return value.slice(0, 80);
  } catch {
    return 'dev';
  }
}
